// globalData.js
export const globalData = {
  shippingType: null,
  currentItem: null,
  selectedSize: null,
  shippingData: {
    nome: '',
    cognome: '',
    postalCode: '',
    locality: '',
    province: '',
    via: '',
    email: '',
    phone: '',
  },
  setShippingType(item) {
    this.shippingType = item;
  },
  setCurrentItem(item) {
    this.currentItem = item;
  },
  setSelectedSize(size) {
    this.selectedSize = size;
  },
  setShippingData(data) {
    this.shippingData = { ...this.shippingData, ...data };
  }
};
